import { useEffect } from "react";
import { Link } from "react-router-dom";
import OpsHeader from "@/components/opsiq/OpsHeader";
import OpsFooter from "@/components/opsiq/OpsFooter";
import ScrollProgress from "@/components/opsiq/ScrollProgress";
import { ArrowUpRight } from "lucide-react";

export default function PageShell({ eyebrow, title, subtitle, children, testid = "page" }) {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div data-testid={testid} className="min-h-screen bg-[#1A2E4A] text-[#F1ECE0] font-plex ops-select">
      <ScrollProgress />
      <OpsHeader />
      <section className="relative overflow-hidden">
        <div className="absolute -top-40 -left-40 h-[420px] w-[420px] rounded-full bg-[#D9FF3C]/8 blur-[120px] pointer-events-none" />
        <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 pt-14 md:pt-20 pb-12 md:pb-16">
          {eyebrow && (
            <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#D9FF3C] mb-5 inline-flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#D9FF3C]" />
              {eyebrow}
            </div>
          )}
          <h1 data-testid={`${testid}-title`} className="font-editorial text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight text-[#F1ECE0] max-w-4xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-base md:text-lg text-[#F1ECE0]/75 max-w-2xl leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
      </section>

      <main>{children}</main>

      <section className="relative bg-[#F1ECE0] text-[#1A2E4A] border-t border-[#1A2E4A]/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="max-w-2xl">
            <div className="text-[11px] uppercase tracking-[0.25em] font-semibold text-[#1A2E4A] mb-3 inline-flex items-center gap-2">
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#B8E024]" />
              Ready when you are
            </div>
            <h3 className="font-editorial text-3xl md:text-4xl leading-tight tracking-tight text-[#1A2E4A]">
              Book a 30-minute working session with a principal.
            </h3>
          </div>
          <Link to="/book" className="inline-flex items-center gap-2 px-6 py-4 bg-[#1A2E4A] text-[#F1ECE0] text-xs uppercase tracking-[0.22em] font-semibold hover:bg-[#D9FF3C] hover:text-[#142645] transition-colors">
            Book consultation <ArrowUpRight size={16} />
          </Link>
        </div>
      </section>

      <OpsFooter />
    </div>
  );
}
